function range(start, end, step = 1) {
  return Array.from({ length: Math.floor(Math.abs(end - start) / step) + 1 }, (_, i) => start + i * (end > start ? 1 : -1) * Math.abs(step));
}
export {
  range
};
//# sourceMappingURL=range.js.map
